import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/movies";
import { formatHeat, typeMeta } from "@/lib/media";

const topList = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 6);

export default function HotRanking() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16" aria-label="站内热度榜">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">Weekly ranking</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">
            站内热度榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按浏览热度排序，看看这周大家都在关注哪些作品。
          </p>
        </div>
        <Link
          to="/category/tv?sort=hot"
          className="inline-flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          查看热度排行
          <i className="ri-arrow-right-up-line" />
        </Link>
      </div>

      <div className="grid gap-x-10 gap-y-1 lg:grid-cols-2">
        {topList.map((item, index) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex cursor-pointer items-center gap-4 rounded-md px-2 py-3 transition-colors hover:bg-background-100"
          >
            <span
              className={`w-8 shrink-0 font-heading text-2xl font-bold ${
                index < 3 ? "text-accent-500" : "text-foreground-300"
              }`}
            >
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 海报`}
                title={`${item.title} - 蜜桃33热度榜`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900">
                  {typeMeta[item.type].label}
                </span>
              </span>
              <span className="mt-1 block truncate text-[11px] text-foreground-500">
                {item.year} · {item.region} · {item.genres.slice(0, 2).join(" / ")}
              </span>
            </span>
            <span className="hidden shrink-0 items-center gap-1 text-[11px] text-foreground-500 sm:flex">
              <i className="ri-fire-line text-accent-500" />
              {formatHeat(item.heat)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}